import classNames from "classnames";
import {Localizer} from "../../../infrastructure/localization/localizer";
import React from "react";
import useScreenResolution from "../../../core/hooks/useScreenResolution";
import {GetDescription, GetInfoIconDescription, GetSubject} from "./DashboardOpmaerksomhedspunkterEnum";
import {DashboardOpmaerksomhedCard} from "./dashboardOpmaerksomhedCard";
import useDashboardOpmaerksomhedspunkter from "./useDashboardOpmaerksomhedspunkter";

type DashboardOpmaerksomhedspunkterProps = {}
const DashboardOpmaerksomhedspunkter = ({}: DashboardOpmaerksomhedspunkterProps) => {
    const {isMobile} = useScreenResolution();

    const {
        opmaerksomhedspunkter,
        OpmaerksomhedspunktIsLoading,
        GetAmountFromOpmaerksomhedsType,
        GetNavigationCallback
    } = useDashboardOpmaerksomhedspunkter();

    return <>
        <div className={classNames("card", !isMobile && "card-50")}>
            <div className="card-header">
                <h4 className="card-title">{Localizer.dashboard_opmaerksomhedspunkter()}</h4>
            </div>
            <div className="card-body">
                <div className={classNames("flex-container-column")} style={{height: "100%"}}>
                    {opmaerksomhedspunkter.map((enumItem, index) => {
                        const description = GetDescription(enumItem);
                        return <DashboardOpmaerksomhedCard
                                key={index}
                                opmaerksomhedspunkt={enumItem}
                                text={description}
                                subjectText={GetSubject(enumItem)}
                                amount={GetAmountFromOpmaerksomhedsType(enumItem)}
                                infoText={GetInfoIconDescription(enumItem)}
                                isLoading={OpmaerksomhedspunktIsLoading(enumItem)}
                                handleClickCallback={GetNavigationCallback(enumItem)}
                            />
                    })}
                </div>
            </div>
        </div>
    </>
}
export default DashboardOpmaerksomhedspunkter;
